/**
 * @generated SignedSource<<0d51c0990eb5c336b8629c1d85c81776>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CBPayAssetFilters = {
  networks?: ReadonlyArray<string> | null;
  tickers?: ReadonlyArray<string> | null;
};
export type selectAssetV2Query$variables = {
  filter: CBPayAssetFilters;
};
export type selectAssetV2Query$data = {
  readonly viewer: {
    readonly " $fragmentSpreads": FragmentRefs<"AssetListFragment" | "useRunChecksAgainstAssetListFragment" | "useSelectAssetTabsFragment">;
  };
};
export type selectAssetV2Query = {
  response: selectAssetV2Query$data;
  variables: selectAssetV2Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filter"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uuid",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imageUrl",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v9 = [
  (v6/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v11 = [
  (v10/*: any*/),
  (v8/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetBalanceBreakdown",
  "kind": "LinkedField",
  "name": "assetBalanceBreakdown",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Amount",
      "kind": "LinkedField",
      "name": "availableToSendBalance",
      "plural": false,
      "selections": (v11/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Amount",
      "kind": "LinkedField",
      "name": "availableToSendBalanceFiat",
      "plural": false,
      "selections": (v11/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "selectAssetV2Query",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": null,
          "concreteType": "Viewer",
          "kind": "LinkedField",
          "name": "viewer",
          "plural": false,
          "selections": [
            {
              "args": (v1/*: any*/),
              "kind": "FragmentSpread",
              "name": "AssetListFragment"
            },
            {
              "args": (v1/*: any*/),
              "kind": "FragmentSpread",
              "name": "useSelectAssetTabsFragment"
            },
            {
              "args": (v1/*: any*/),
              "kind": "FragmentSpread",
              "name": "useRunChecksAgainstAssetListFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW",
        "path": "viewer"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "selectAssetV2Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "CbPayAssetConnection",
            "kind": "LinkedField",
            "name": "cbPayTradableAssets",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CBPayAssetEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CBPayAsset",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      (v3/*: any*/),
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "exponent",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "NetworkMetadata",
                        "kind": "LinkedField",
                        "name": "networks",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "displayName",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minSend",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isDefault",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "quoteCurrency",
                            "value": "USD"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "marketCap",
                        "storageKey": "marketCap(quoteCurrency:\"USD\")"
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountConnection",
            "kind": "LinkedField",
            "name": "accountsV2",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Amount",
                        "kind": "LinkedField",
                        "name": "availableBalanceInNativeCurrency",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "assetOrFiatCurrency",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v9/*: any*/),
                            "type": "Node",
                            "abstractKey": "__isNode"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v6/*: any*/),
                              (v7/*: any*/),
                              (v12/*: any*/)
                            ],
                            "type": "TiersCurrency",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v9/*: any*/),
                            "type": "ViewerEquity",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Asset",
                                "kind": "LinkedField",
                                "name": "asset",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v6/*: any*/),
                                  (v4/*: any*/),
                                  (v3/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v12/*: any*/)
                            ],
                            "type": "ViewerAsset",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Amount",
                        "kind": "LinkedField",
                        "name": "availableBalance",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v3/*: any*/),
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "primary",
                        "storageKey": null
                      },
                      (v6/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1fc725d2193a50f28806ef28809fedf2",
    "id": null,
    "metadata": {},
    "name": "selectAssetV2Query",
    "operationKind": "query",
    "text": "query selectAssetV2Query(\n  $filter: CBPayAssetFilters!\n) {\n  viewer {\n    ...AssetListFragment_Vt7Yj\n    ...useSelectAssetTabsFragment_Vt7Yj\n    ...useRunChecksAgainstAssetListFragment_Vt7Yj\n    id\n  }\n}\n\nfragment AssetListCellFragment on CBPayAsset {\n  uuid\n  name\n  symbol\n  imageUrl\n}\n\nfragment AssetListFragment_Vt7Yj on Viewer {\n  cbPayTradableAssets(filter: $filter) {\n    edges {\n      node {\n        ...AssetListCellFragment\n        ...readCBPayAssetAsOnrampStateFragment\n        ...reduceCBPayAssetsBySearchTermFragment\n        ...useFilterCBPayAssetsByDestinationWalletsFragment\n        ...readCBPayAssetUuidFragment\n        uuid\n        symbol\n        marketCap(quoteCurrency: \"USD\")\n        id\n      }\n    }\n  }\n  accountsV2 {\n    edges {\n      node {\n        ...filterCryptoAccountsByBalanceFragment\n        ...readAccountViewerAssetUuidFragment\n        ...CryptoAccountListCellFragment\n        uuid\n        primary\n        availableBalanceInNativeCurrency {\n          value\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment CryptoAccountListCellFragment on Account {\n  ...readAccountBalanceFragment\n  ...readAccountBalanceFiatFragment\n  name\n  assetOrFiatCurrency {\n    __typename\n    ... on ViewerAsset {\n      asset {\n        uuid\n        symbol\n        name\n        imageUrl\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on TiersCurrency {\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment filterCryptoAccountsByBalanceFragment on Account {\n  type\n  availableBalanceInNativeCurrency {\n    value\n  }\n  assetOrFiatCurrency {\n    __typename\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on TiersCurrency {\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readAccountBalanceFiatFragment on Account {\n  assetOrFiatCurrency {\n    __typename\n    ... on TiersCurrency {\n      assetBalanceBreakdown {\n        availableToSendBalanceFiat {\n          currency\n          value\n        }\n      }\n      id\n    }\n    ... on ViewerAsset {\n      assetBalanceBreakdown {\n        availableToSendBalanceFiat {\n          currency\n          value\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readAccountBalanceFragment on Account {\n  availableBalance {\n    currency\n  }\n  assetOrFiatCurrency {\n    __typename\n    ... on TiersCurrency {\n      type\n      assetBalanceBreakdown {\n        availableToSendBalance {\n          currency\n          value\n        }\n      }\n      id\n    }\n    ... on ViewerAsset {\n      assetBalanceBreakdown {\n        availableToSendBalance {\n          currency\n          value\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readAccountViewerAssetUuidFragment on Account {\n  assetOrFiatCurrency {\n    __typename\n    ... on ViewerAsset {\n      asset {\n        uuid\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n    ... on TiersCurrency {\n      id\n    }\n    ... on ViewerEquity {\n      id\n    }\n  }\n}\n\nfragment readCBPayAssetAsOnrampStateFragment on CBPayAsset {\n  uuid\n  symbol\n  imageUrl\n  name\n  exponent\n  networks {\n    name\n    displayName\n    minSend\n    isDefault\n  }\n}\n\nfragment readCBPayAssetUuidFragment on CBPayAsset {\n  uuid\n}\n\nfragment reduceCBPayAssetsBySearchTermFragment on CBPayAsset {\n  symbol\n  name\n}\n\nfragment useFilterCBPayAssetsByDestinationWalletsFragment on CBPayAsset {\n  uuid\n  symbol\n  networks {\n    name\n  }\n}\n\nfragment useRunChecksAgainstAssetListFragment_Vt7Yj on Viewer {\n  cbPayTradableAssets(filter: $filter) {\n    edges {\n      node {\n        ...useFilterCBPayAssetsByDestinationWalletsFragment\n        ...readCBPayAssetAsOnrampStateFragment\n        id\n      }\n    }\n  }\n}\n\nfragment useSelectAssetTabsFragment_Vt7Yj on Viewer {\n  cbPayTradableAssets(filter: $filter) {\n    edges {\n      node {\n        ...readCBPayAssetUuidFragment\n        id\n      }\n    }\n  }\n  accountsV2 {\n    edges {\n      node {\n        ...filterCryptoAccountsByBalanceFragment\n        ...readAccountViewerAssetUuidFragment\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d42f7b3b5691a30cf481f93401f7def5";

export default node;
